import React from "react";
import DashboardHeader from '../../components/admincomponents/DashboardHeader';import ProjectsList from '../../components/admincomponents/ProjectsList';
import ProjectsListByCategory from "../../components/admincomponents/ProjectsListByCategory";

function AdminProjectsCategory({onLogout}) {
  return (
    <>
      <DashboardHeader onLogout={onLogout}/>
      <ProjectsListByCategory />            
    </>
  );
}

export default AdminProjectsCategory;
